import { Paper, Group, Title, Button, Skeleton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { FullMainHeight } from '@ui';

export const PageSkeleton = () => {
  const { t } = useTranslation();
  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Group justify="space-between">
            <Title order={2}>{t('common.batch')} :</Title>
            <Group>
              <Button disabled>{t('common.valider-ma-saisie')}</Button>
              <Button color="red" disabled>
                {t('common.back')}
              </Button>
            </Group>
          </Group>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <Group h="100%" wrap="nowrap">
          <Skeleton h="100%" w={470} />
          <Skeleton flex={1} h="100%" w="100%" />
        </Group>
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
};
